import React from "react";

export const WAHeaderNav: React.FC<{}> = props => (
  <div className="wa-header-nav">{props.children}</div>
);
